export const messages = {
  onSuccess: 'Thank you! Your response has been submitted.',
  onError: 'There was an error in processing your submission. Please try again.',
  onLoadingError: 'There was an error while loading the page. Please try again.',
}
